//import { history } from '../utils/history';
import { dummyDatas } from './dummy.datas';
import { history } from '../utils/history';
import { authService } from './auth.services';
import { isMobile } from 'react-device-detect';
import { message } from 'antd';
import i18n from "../i18n";

const { apiUrlDev, apiUrlProduct, dummyDataActive } = window['runConfig'];

let apiUrl;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    // dev code
    apiUrl = apiUrlProduct;
    //apiUrl = apiUrlDev;
} else {
    // production code
    apiUrl = apiUrlProduct;
}

export async function callApi(serviceName, options) {
    if (dummyDataActive) {
        return Promise.resolve(dummyDatas[serviceName]);
    } else {
        return await _callApi(serviceName, options || {});
    }
}

async function _callApi(serviceName, options) {
    let method = options.method ? options.method : 'GET';
    let headers;
    if (!serviceName.endsWith("Authenticate")) {
        const authStorage = JSON.parse(localStorage.getItem('AuthStorage'));
        const token = authStorage?.user?.token || "";
        headers = { "Authorization": `Bearer ${token}` };
    }

    if (options.contentType === "form-data") {
        headers = { ...headers, "Content-Type": "application/x-www-form-urlencoded" }
    } else if (options.contentType === "multipart") {
        // STOP! Do not add the following header! It automatically appends this header with some extra info
    } else {
        headers = { ...headers, "Content-Type": "application/json" }
    }

    const requestOptions = {
        method: method,
        body: options.data,
        headers: headers
    };

    let data;
    try {
        const response = await window.fetch(`${apiUrl}/${serviceName}`, requestOptions);
        if (!response.ok) {
            if (response.status === 401) {
                //auto logout if 401 response returned from api
                if (isMobile) {
                    message.warning(i18n.t("pleaseloginagain"))
                    window.location.replace("/");
                    authService.logout();
                } else {
                    history.push({
                        pathname: `/login`,
                        search: `?${window.location.pathname}`,
                        state: { referrer: window.location.pathname }
                    });
                    authService.logout();
                    window.location.reload(true);
                }
            }
            data = await response.json();
            return Promise.reject(data);
        }
        if (response.headers.get("Content-Type").indexOf("text/plain") > -1) {
            data = await response.text();
        } else if (response.headers.get("Content-Type").indexOf("application/json") > -1) {
            data = await response.json();
        } else {
            var blob = await response.blob();
            data = URL.createObjectURL(blob);
        }

        return data.ResultData ?? data;
    } catch (err) {
        return Promise.reject(err.message ? err.message : data);
    }
}











